// CSS Modules - component class name prefix: ProductArea__

<template>
  <nav :class="$style.container">
    <ul
      :class="[$style.menu, 'columns']"
      v-tippy="{
        theme: 'wika light',
        interactive: true,
        reactive: true,
        placement: 'top',
        flip: false,
        animation: 'fade',
        duration: [200, 600],
        animateFill: false,
        arrow: false,
        distance: 0,
        html: '#productAreaCloud',
        trigger: 'mouseenter focus'
      }"
      @init="initProductAreaPopper"
      @hide="(currentLink = undefined), (isCloudLoading = true)"
    >
      <li
        v-for="link in productLinks"
        :key="link.id"
        :class="[$style.menuItem, 'column']"
        @mouseenter="(currentLink = link), (isCloudLoading = true)"
      >
        <a :href="link.url" @click.prevent="setLastClicked(link)">
          <span>{{ link.title }}</span>
        </a>
      </li>
    </ul>
    <div id="productAreaCloud" :class="$style.popupContent">
      <div v-if="currentLink">
        <h2>{{ currentLink.title }}</h2>
        <div class="columns is-variable is-8">
          <div class="column is-one-third">
            <p v-html="currentLink.text"></p>
          </div>
          <div :class="[$style.cloud, 'column is-two-thirds']">
            <img
              v-if="
                currentLink.words && currentLink.words.length && isCloudLoading
              "
              :src="loadingGif"
              :class="$style.cloudLoading"
            />
            <vue-word-cloud
              :words="currentLink.words || [[]]"
              font-family="Helvetica, Arial"
              :animation-duration="0"
              :spacing="0.5"
              :font-size-ratio="3"
              @update:progress="handleCloudUpdateProgress"
            >
              <template slot-scope="slotProps">
                <a
                  :href="slotProps.word[2]"
                  :class="$style.tag"
                  :target="getLinkTarget(slotProps.word)"
                >
                  {{ slotProps.text }}
                </a>
              </template>
            </vue-word-cloud>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import VueWordCloud from "vuewordcloud";
import LoadingGif from "../../assets/loading.gif";

export default {
  name: "ProductArea",
  components: {
    "vue-word-cloud": VueWordCloud
  },
  props: {
    productLinks: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isTouch: "ontouchstart" in document.documentElement,
      isCloudLoading: true,
      loadingGif: LoadingGif,
      currentLink: undefined,
      lastClickedId: undefined
    };
  },
  methods: {
    handleCloudUpdateProgress(event) {
      if (
        this.isCloudLoading &&
        !!event &&
        event.completedWords &&
        event.totalWords &&
        event.completedWords === event.totalWords
      ) {
        this.isCloudLoading = false;
      }
    },
    setLastClicked(link) {
      if (!this.isTouch || this.lastClickedId === link.id) {
        window.location.href = link.url;
        return;
      }

      this.lastClickedId = link.id;
    },
    initProductAreaPopper(tippy) {
      tippy.popper.id = "productAreaPopper";
    },
    getLinkTarget(propsArr) {
      return propsArr[3] ? "_blank" : "_self";
    }
  }
};
</script>

<style module lang="scss">
@import "./ProductArea.scss";
</style>
